import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-product-kit-gallery',
  templateUrl: './product-kit-gallery.component.html',
  styleUrls: ['./product-kit-gallery.component.scss']
})
export class ProductKitGalleryComponent implements OnInit, OnChanges {

  @Input() gallery;
  @Input() buttons: { label: string, action: () => void, outline?: boolean }[];
  @ViewChild(SwiperDirective, {static: true}) swiper: SwiperDirective;
  public readonly config: SwiperConfigInterface = {
    autoplay: false,
    loop: false,
    freeMode: false,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpointsInverse: true,
    navigation: false,
    mousewheel: false
  };

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.gallery && this.swiper) {
      this.swiper.update();
    }
  }

}
